import Loading from '@/common/components/Loading';
import Table from '@/common/components/Table';
import { WrapperWithScroll } from '@/common/styles/Wrappers';
import { getPageEventsReportTableHeaders } from './helpers/getTableHeaders';
import { getPageEventsReportTableRows } from './helpers/getTableRows';
import usePageEventsReport from './hooks/usePageEventsReport';
import PageEventsReportSearchBox from './components/PageEventsReportSearchBox';

const PageEventsReport = () => {
	const hook = usePageEventsReport();

	return (
		<>
			{hook.isLoading && <Loading />}
			<WrapperWithScroll>
				<PageEventsReportSearchBox
					handleSearchCallback={hook.fetchPageEventsReportData}
				></PageEventsReportSearchBox>
				{hook.data && (
					<>
						<Table
							className='styled-table'
							raws={getPageEventsReportTableRows(hook.data)}
							headers={getPageEventsReportTableHeaders()}
						/>
					</>
				)}
			</WrapperWithScroll>
		</>
	);
};

export default PageEventsReport;
